import './SocialMediaItem.css';

const SocialMediaItem = (props) => {
  return (
    <a
      href={props.url}
      className="social__a"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        className="social__img"
        src={`/images/${props.img}`}
        alt={props.alt}
      />
    </a>
  );
};

export default SocialMediaItem;
